// Route names for auth-only routes (login/signup/etc)
export const AUTH_ONLY_ROUTES = [
  'Login',
  'Signup',
  'ForgotPassword',
  'ResetPassword',
  'AuthCallback',
  'EmailConfirmation'
]

// Route names for public routes (accessible by both authenticated and unauthenticated users)
export const PUBLIC_ROUTES = [
  'Login',
  'Signup',
  'ForgotPassword',
  'ResetPassword',
  'AuthCallback',
  'EmailConfirmation'
]

// Route names for full screen views (with or without auth)
export const FULL_SCREEN_ROUTES = [...PUBLIC_ROUTES, 'Onboarding']

// Helper function to check if a route is public
export const isPublicRoute = routeName => PUBLIC_ROUTES.includes(routeName)

// Helper function to check if a route should be full screen
export const isFullScreenRoute = routeName => FULL_SCREEN_ROUTES.includes(routeName)

// Helper function to check if a route is auth-only
export const isAuthOnlyRoute = routeName => AUTH_ONLY_ROUTES.includes(routeName)
